<template>
      <div class="hl-wid ww3 adm-list">
        <ul class="tab-like">
          <li class="head">
            <ul>
              <li class="title" v-on:click.prevent="toggleSort('title')">
                <span>Title</span>
                <a href="" class="s-inc" :class="{active: sort.title===true}"></a>
                <a href="" class="s-dec" :class="{active: sort.title===false}"></a>
              </li>
<!--              <li class="type" v-on:click.prevent="toggleSort('type')">
                <span>Group</span>
                <a href="" class="s-inc" :class="{active: sort.type===true}"></a>
                <a href="" class="s-dec" :class="{active: sort.type===false}"></a>
              </li>-->
              <li class="type" v-on:click.prevent="toggleSort('type')">
                <span>Type</span>
                <a href="" class="s-inc" :class="{active: sort.type===true}"></a>
                <a href="" class="s-dec" :class="{active: sort.type===false}"></a>
              </li>
              <li class="language" v-on:click.prevent="toggleSort('language')">
                <span>Language</span>
                <a href="" class="s-inc" :class="{active: sort.language===true}"></a>
                <a href="" class="s-dec" :class="{active: sort.language===false}"></a>
              </li>
              <li class="author" v-on:click.prevent="toggleSort('author')">
                <span>Author</span>
                <a href="" class="s-inc" :class="{active: sort.author===true}"></a>
                <a href="" class="s-dec" :class="{active: sort.author===false}"></a>
              </li>
              <li class="date" v-on:click.prevent="toggleSort('created')">
                <span>Date</span>
                <a href="" class="s-inc" :class="{active: sort.created===true}"></a>
                <a href="" class="s-dec" :class="{active: sort.created===false}"></a>
              </li>
              <li class="remove"></li>
            </ul>
          </li>
          <template v-for="(item, ii) in items" v-if="!item.parent">
            <li>
              <ul>
                <li class="title"><router-link :to="{name: 'content.postedit', params: {id: item.id}}">
                  <em v-if="item.subtitle">{{ item.subtitle }}</em>
                  {{ item.title }}
                </router-link></li>
<!--               <li class="type">{{ item.group?item.group.title:"no group" }}</li> -->
                <li class="type">{{ item.type?item.type.title:"no type" }}</li>
                <li class="language">{{ item.language }}</li>
                <li class="author">{{ item.author?item.author.firstname+" "+item.author.lastname:"no author" }}</li>
                <li class="date">{{ item.created }}</li>
                <li class="remove"><a href="" v-on:click.prevent="remove(ii)">remove</a></li>
                <router-link class="link-full" :to="{name: 'content.postedit', params: {id: item.id}}"></router-link>
              </ul>
              <div class="file">
                <span class="file" v-if="item.password">Quiz password: {{ item.password }}</span>
                <span class="file" v-else>{{ item.media && item.media.name }}</span>
              </div>
            </li>
            <li v-for="(item2, ii2) in itemsForParent(item)">
              <ul style="border-left: 2px solid #48c; padding-left: 18px;">
                <li class="title"><router-link :to="{name: 'content.postedit', params: {id: item2.id}}">
                  <em v-if="item2.parent.subtitle">{{ item2.parent.subtitle }}</em>
                  {{ item2.title }}
                </router-link></li>
                <li class="type">{{ item2.type?item2.type.title:"no type" }}</li>
                <li class="language">{{ item2.language }}</li>
                <li class="author">{{ item2.author?item2.author.firstname+" "+item2.author.lastname:"no author" }}</li>
                <li class="date">{{ item2.created }}</li>
                <li class="remove"><a href="" v-on:click.prevent="remove(ii2)">remove</a></li>
                <router-link class="link-full" :to="{name: 'content.postedit', params: {id: item2.id}}"></router-link>
              </ul>
              <div class="file" style="border-left: 2px solid #48c; padding-left: 18px;">
                <span class="file" v-if="item2.password">Quiz password: {{ item2.password }}</span>
                <span class="file" v-else>{{ item2.media && item2.media.name }}</span>
              </div>
            </li>
          </template>
        </ul>
      </div>
</template>

<script>
import api from './api';
export default {
  props: ["type", "user"],
  data: ()=>({
    entity: "Video",
    items: [],
    sort: {title: null},
  }),
  computed: {
    sortedItems() {
      var items=items.slice();
      return items;
    },
  },
  created() {
    this.listItems();
  },
  methods: {
    itemsForParent(parent) {
      return this.items.filter(a=>a.parent && a.parent.id == parent.id);
    },
    toggleSort(column) {
      if (this.sort[column]===null)
        this.sort[column]=true;
      else if (this.sort[column]===true)
        this.sort[column]=false;
      else if (this.sort[column]===false)
        this.sort[column]=null;
    },
    async listItems() {
      var where={/*posttype: this.type*/};
      if (this.user)
        where.author=this.user.id;
      var items=(await api.list(this.entity, where, ["id:DESC"], 0, 0, ["blocks", "parent.blocks", "parent.allVideos", "allVideos"])).items;
      items.sort((a,b)=>{
        if (a.id*1<b.id*1) return 1;
        if (a.id*1>b.id*1) return -1;
        return 0;
      });
      this.items=items;
    },
    select(index) {
      this.$emit("select", this.items[index]);
    },
    async remove(index) {
      if (!confirm("Are you sure?"))
        return;
      var items=this.items.splice(index, 1);
      for(var item of items) {
        await api.delete("Video", item.id);
      }
    },
  }
}
</script>
